const Fragment = {
	functional: true,
	render (h, ctx) {
		return ctx.children
	}
}

export default Fragment



// WEBPACK FOOTER //
// ./src/components/Fragment/index.js